// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__21hVc","signatureBlock":"Footer_signatureBlock__AEiYH","signature":"Footer_signature__3lYP6"};